// top 50 countries by GDP, ordered alphabeticaly
export const COUNTRY_CODES = [
  { locale: 'es-AR', value: '+54', label: 'Argentina (+54)' },
  { locale: 'en-AU', value: '+61', label: 'Australia (+61)' },
  { locale: 'de-AT', value: '+43', label: 'Austria (+43)' },
  { locale: 'bn-BD', value: '+880', label: 'Bangladesh (+880)' },
  { locale: 'nl-BE', value: '+32', label: 'Belgium (+32)' },
  { locale: 'pt-BR', value: '+55', label: 'Brazil (+55)' },
  { locale: 'en-CA', value: '+1 (en-CA)', label: 'Canada (+1)' },
  { locale: 'es-CL', value: '+56', label: 'Chile (+56)' },
  { locale: 'zh-CN', value: '+86', label: 'China (+86)' },
  { locale: 'es-CO', value: '+57', label: 'Colombia (+57)' },
  { locale: 'cs-CZ', value: '+420', label: 'Czech Republic (+420)' },
  { locale: 'da-DK', value: '+45', label: 'Denmark (+45)' },
  { locale: 'ar-EG', value: '+20', label: 'Egypt (+20)' },
  { locale: 'fi-FI', value: '+358', label: 'Finland (+358)' },
  { locale: 'fr-FR', value: '+33', label: 'France (+33)' },
  { locale: 'de-DE', value: '+49', label: 'Germany (+49)' },
  { locale: 'zh-HK', value: '+852', label: 'Hong Kong (+852)' },
  { locale: 'hi-IN', value: '+91', label: 'India (+91)' },
  { locale: 'id-ID', value: '+62', label: 'Indonesia (+62)' },
  { locale: 'fa-IR', value: '+98', label: 'Iran (+98)' },
  { locale: 'ar-IQ', value: '+964', label: 'Iraq (+964)' },
  { locale: 'en-IE', value: '+353', label: 'Ireland (+353)' },
  { locale: 'he-IL', value: '+972', label: 'Israel (+972)' },
  { locale: 'it-IT', value: '+39', label: 'Italy (+39)' },
  { locale: 'ja-JP', value: '+81', label: 'Japan (+81)' },
  { locale: 'ms-MY', value: '+60', label: 'Malaysia (+60)' },
  { locale: 'es-MX', value: '+52', label: 'Mexico (+52)' },
  { locale: 'nl-NL', value: '+31', label: 'Netherlands (+31)' },
  { locale: 'en-NG', value: '+234', label: 'Nigeria (+234)' },
  { locale: 'nb-NO', value: '+47', label: 'Norway (+47)' },
  { locale: 'ur-PK', value: '+92', label: 'Pakistan (+92)' },
  { locale: 'tl-PH', value: '+63', label: 'Philippines (+63)' },
  { locale: 'pl-PL', value: '+48', label: 'Poland (+48)' },
  { locale: 'pt-PT', value: '+351', label: 'Portugal (+351)' },
  { locale: 'ro-RO', value: '+40', label: 'Romania (+40)' },
  { locale: 'ru-RU', value: '+7', label: 'Russia (+7)' },
  { locale: 'ar-SA', value: '+966', label: 'Saudi Arabia (+966)' },
  { locale: 'en-SG', value: '+65', label: 'Singapore (+65)' },
  { locale: 'en-ZA', value: '+27', label: 'South Africa (+27)' },
  { locale: 'ko-KR', value: '+82', label: 'South Korea (+82)' },
  { locale: 'es-ES', value: '+34', label: 'Spain (+34)' },
  { locale: 'sv-SE', value: '+46', label: 'Sweden (+46)' },
  { locale: 'de-CH', value: '+41', label: 'Switzerland (+41)' },
  { locale: 'zh-TW', value: '+886', label: 'Taiwan (+886)' },
  { locale: 'th-TH', value: '+66', label: 'Thailand (+66)' },
  { locale: 'tr-TR', value: '+90', label: 'Turkey (+90)' },
  { locale: 'ar-AE', value: '+971', label: 'United Arab Emirates (+971)' },
  { locale: 'en-GB', value: '+44', label: 'United Kingdom (+44)' },
  { locale: 'en-US', value: '+1 (en-US)', label: 'United States (+1)' },
  { locale: 'vi-VN', value: '+84', label: 'Vietnam (+84)' }
];